exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-1ddd5a27] {\n  background: transparent;\n  border: 0;\n}\n.card .card-header[data-v-1ddd5a27] {\n  color: #333;\n  font-size: 0.875rem;\n  border-bottom: 1px dotted #333;\n  padding: 0 0 0.25rem 0;\n  margin-bottom: 0.125rem;\n  background: transparent;\n}\n.card label[data-v-1ddd5a27] {\n  color: #333;\n}\n.card a.filter-show-more[data-v-1ddd5a27] {\n  font-size: 0.9rem;\n  cursor: pointer;\n  color: #333;\n}", ""]);

// exports
